'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var errcode = require('err-code');

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var PeerId = require('peer-id');

var AddressBook = require('./address-book');

var KeyBook = require('./key-book');

var MetadataBook = require('./metadata-book');

var ProtoBook = require('./proto-book');

var _require2 = require('../errors'),
    ERR_INVALID_PARAMETERS = _require2.codes.ERR_INVALID_PARAMETERS;
/**
 * @typedef {import('./address-book').Address} Address
 */

/**
 * @extends {EventEmitter}
 *
 * @fires PeerStore#peer Emitted when a new peer is added.
 * @fires PeerStore#change:protocols Emitted when a known peer supports a different set of protocols.
 * @fires PeerStore#change:multiaddrs Emitted when a known peer has a different set of multiaddrs.
 * @fires PeerStore#change:pubkey Emitted emitted when a peer's public key is known.
 * @fires PeerStore#change:metadata Emitted when the known metadata of a peer change.
 */


var PeerStore = /*#__PURE__*/function (_EventEmitter) {
  _inherits(PeerStore, _EventEmitter);

  var _super = _createSuper(PeerStore);

  /**
   * Peer object
   *
   * @typedef {Object} Peer
   * @property {PeerId} id peer's peer-id instance.
   * @property {Address[]} addresses peer's addresses containing its multiaddrs and metadata.
   * @property {string[]} protocols peer's supported protocols.
   * @property {Map<string, Uint8Array>|undefined} metadata peer's metadata map.
   */

  /**
   * Responsible for managing known peers, as well as their addresses, protocols and metadata.
   *
   * @param {object} options
   * @param {PeerId} options.peerId
   * @class
   */
  function PeerStore(_ref) {
    var _this;

    var peerId = _ref.peerId;

    _classCallCheck(this, PeerStore);

    _this = _super.call(this);
    _this._peerId = peerId;
    /**
     * AddressBook containing a map of peerIdStr to Address.
     */

    _this.addressBook = new AddressBook(_assertThisInitialized(_this));
    /**
     * KeyBook containing a map of peerIdStr to their PeerId with public keys.
     */

    _this.keyBook = new KeyBook(_assertThisInitialized(_this));
    /**
     * MetadataBook containing a map of peerIdStr to their metadata Map.
     */

    _this.metadataBook = new MetadataBook(_assertThisInitialized(_this));
    /**
     * ProtoBook containing a map of peerIdStr to supported protocols.
     */

    _this.protoBook = new ProtoBook(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Start the PeerStore.
   */


  _createClass(PeerStore, [{
    key: "start",
    value: function start() {}
    /**
     * Stop the PeerStore.
     */

  }, {
    key: "stop",
    value: function stop() {}
    /**
     * Get all the stored information of every peer known.
     *
     * @returns {Map<string, Peer>}
     */

  }, {
    key: "peers",
    get: function get() {
      var _this2 = this;

      var storedPeers = new Set([].concat(_toConsumableArray(this.addressBook.data.keys()), _toConsumableArray(this.keyBook.data.keys()), _toConsumableArray(this.protoBook.data.keys()), _toConsumableArray(this.metadataBook.data.keys()))); // Remove self peer if present

      this._peerId && storedPeers.delete(this._peerId.toB58String());
      var peersData = new Map();
      storedPeers.forEach(function (idStr) {
        peersData.set(idStr, _this2.get(PeerId.createFromB58String(idStr)));
      });
      return peersData;
    }
    /**
     * Delete the information of the given peer in every book.
     *
     * @param {PeerId} peerId
     * @returns {boolean} true if found and removed
     */

  }, {
    key: "delete",
    value: function _delete(peerId) {
      var addressesDeleted = this.addressBook.delete(peerId);
      var keyDeleted = this.keyBook.delete(peerId);
      var protocolsDeleted = this.protoBook.delete(peerId);
      var metadataDeleted = this.metadataBook.delete(peerId);
      return addressesDeleted || keyDeleted || protocolsDeleted || metadataDeleted;
    }
    /**
     * Get the stored information of a given peer.
     *
     * @param {PeerId} peerId
     * @returns {Peer|undefined}
     */

  }, {
    key: "get",
    value: function get(peerId) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      var id = this.keyBook.data.get(peerId.toB58String());
      var addresses = this.addressBook.get(peerId);
      var metadata = this.metadataBook.get(peerId);
      var protocols = this.protoBook.get(peerId);

      if (!id && !addresses && !metadata && !protocols) {
        return undefined;
      }

      return {
        id: id || peerId,
        addresses: addresses || [],
        protocols: protocols || [],
        metadata: metadata
      };
    }
  }]);

  return PeerStore;
}(EventEmitter);

module.exports = PeerStore;